// extracted by mini-css-extract-plugin
export default {"trxnListTable":"transactionsTable_trxnListTable__5li9X","trxnStatusPill":"transactionsTable_trxnStatusPill__8dLuU","noDataFound":"transactionsTable_noDataFound__3E-l6"};